import styled from 'styled-components'

export const Container = styled.div`
  h4 {
    font-family: Ubuntu, sans-serif;
    -webkit-font-smoothing: antialiased;
    letter-spacing: 0.2px;
    font-size: 14px;
    text-align: center;
    color: #f39c12;
  }

  .documentation-container {
    max-width: 600px;
    margin: auto;
  }
`
